import { ConditionModel, OptionModel } from 'app/model/checkout/cart-option-detail-model';
import { SearchFormModel } from 'app/model/search-form-model';
import { ChildPolicy } from 'app/model/products/product-detail-info.model';
import { CompanyTravelPolicyUserResponse, HotelPromotion } from './hotel/hotel.model';

export class ProductRoomDetailModel {
  searchId: string;
  hotelId: number;
  rooms: Room[];
  crossCondition: boolean;
  companyTravelPolicyUserResponse: CompanyTravelPolicyUserResponse[] = [];
}

export class Room {
  roomCode: string;
  allotment: number;
  image: string;
  title: string;
  conditions: Condition[];
  roomSize: string;
  roomView: string;
  numberOfBedroom: number;
  numberOfBathroom: number;
  sharedBathroom: boolean;
  bedType: string;
}

export class Condition {
  adult: number;
  child: number;
  breakfast: boolean;
  offerTypeName: String;
  offerTypeDisplay: String;
  netPrice: string;
  totalPrice: string;
  lineItemId: string;
  payOn: string;
  cancellationPolicies: CancellationPolicy[];
  benefits: Benefit[];
  surcharges: Surcharge[];
  extraBed: number;
  promotion: HotelPromotion;
}

export class Surcharge {
  charge: String;
  name: String;
  price: number;
  method: String;
}

export class CancellationPolicy {
  amount: number;
  from: string;
  cancellationId: number;
  dayCancel: number;
}

export class Benefit {
  name: string;
  description: string;
}

export class RoomDetailDto {
  roomDetails: Room[];
  searchFormModel: SearchFormModel;
  crossCondition: boolean;
  searchId: string;
  hotelRemarks: Remark[];
  minGuestAge: number;
  childPolicies: ChildPolicy[];

  constructor(detailList = undefined, search = undefined, searchId = null, crossCondition = true) {
    this.roomDetails = detailList;
    this.searchFormModel = search;
    this.crossCondition = crossCondition;
    this.searchId = searchId;
  }
}

export class Remark {
  th: String;
  en: String;
}
export class RoomConditionDto {
  lineItemId: string;
  hotelId: Number;
  roomCode: string;
  allotment: Number;
  selectAllotment: Number[];
  image: String;
  title: String;
  displayTitle: String;
  adult: Number;
  child: Number;
  breakfast: boolean;
  offerTypeName: String;
  offerTypeDisplay: String;
  netPrice: String;
  totalPrice: String;
  averageTotalPrice: string;
  averageNetPrice: string;
  nonRefundableDescription: String = ``;
  payOn: string = ``;
  paylaterDescription: String = ``;
  lastDayFreeCanllation: String = ``;
  cancellationDescription: String[];
  cancellationPolicies: CancellationPolicy[];
  lastFiveRoom: String;
  quantity: Number;
  benefits: Benefit[];
  extraBed: number;
  isExpand: Boolean = false;
  isOverLimit: Boolean = false;
  isFirstCondition: Boolean = false;
  isCountRow: Number = 1;
  surcharges: Surcharge[];
  displayIncludeSurcharge: String = ``;
  displayExcludeSurcharge: String = ``;
  displayExtraBed: String = ``;
  roomSize: string;
  roomView: string;
  numberOfBedroom: number;
  numberOfBathroom: number;
  sharedBathroom: boolean;
  bedType: string;
  overPrice: number;
  promotion?: HotelPromotion;
  taxesAndFees: number;
  totalPriceExclude: number;

  constructor(option: OptionModel = undefined, condition: ConditionModel = undefined) {
    if (option && condition) {
      this.lineItemId = '' + condition.conditionId;
      this.allotment = option.allotment;
      this.title = option.title;
      this.displayTitle = option.title.toString();
      this.adult = condition.adult;
      this.child = condition.child;
      this.breakfast = condition.breakfast > 0;
      this.netPrice = Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf()).toString();
      this.quantity = condition.quantity;
      this.cancellationPolicies = [];
      this.surcharges = condition.surcharges;
      if (condition.cancellationList.length > 0) {
        this.cancellationPolicies.push(new CancellationPolicy());
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/products/product-room-detail.model.ts